import React from 'react'
import { ViewSwitcher } from './utils/ViewSwitcher.jsx';
import { MobileView } from './components/MobileView/MobileView.jsx';
import { DesktopView } from './components/DesktopView/DesktopView.jsx';

const LeaseSigning = () => {
    return (
        <ViewSwitcher
            MobileLayout={() => (<MobileView />)}
            DesktopLayout={() => (<DesktopView />)}
        />);
}

export { LeaseSigning }